module.exports = "/_next/static/images/search--grey-f2663f5233b4b58397de39dec93d4679.svg";